import React, { useState, useEffect } from 'react';
import './Home.css';
import Typewriter from "typewriter-effect";
import { supabase } from '../supabaseClient';

const Hero = () => {
  const [heroData, setHeroData] = useState({
    full_name: 'DEVAPRASAD',
    hero_image: ''
  });

  useEffect(() => {
    fetchHeroData();
  }, []);

  const fetchHeroData = async () => {
    try {
      const { data, error } = await supabase
        .from('about')
        .select('full_name, hero_image')
        .single();
      
      if (data) {
        setHeroData({
          full_name: data.full_name || 'DEVAPRASAD',
          hero_image: data.hero_image || ''
        });
      }
    } catch (error) {
      console.error('Error fetching hero data:', error);
    }
  };

  return (
    <>
      <section 
        id="hero" 
        className="d-flex flex-column justify-content-center align-items-center"
        style={heroData.hero_image ? { backgroundImage: `url(${heroData.hero_image})` } : {}}
      >
        <div className="hero-container" data-aos="fade-in">
          <h1 className="typing">
            <Typewriter
              options={{
                strings: [heroData.full_name],
                autoStart: true,
                loop: true,
              }}
            />
          </h1>
          <p>I'm a Developer<span className="typed" data-typed-items="Designer, Developer, Freelancer, Photographer"></span></p>
        </div>
      </section>
    </>
  );
}

export default Hero;
